import BigNum from "../math/BigNum";

export default class Upgrade {
    /**
     * @abstract
     * @param {string} title
     * @param {string} iconFileName
     */
    constructor(title, iconFileName) {

        /**
         * @constant
         * @type {string}
         */
        this.title = title;

        /**
         * @constant
         * @type {string}
         */
        this.iconFileName = iconFileName;

        /**
         * @type {number}
         */
        this.purchasedCount = 0;
    }

    /**
     * Optional. Return null if there is none.
     * @returns {string}
     */
    getDescription() {
        return null;
    }

    /**
     * @returns {boolean}
     */
    isPurchasable() {
        return this.isAffordable();
    }
    
    /**
     * @returns {boolean}
     */
    isAffordable() {
        return false;
    }

    /**
     * @abstract
     * @returns {BigNum}
     */
    getCost() {
        return null;
    }

    /**
     * @abstract
     * @returns {string} See UpgradeCostUnit
     */
    getCostUnit() {
        return null;
    }

    /**
     * @returns {number}
     */
    getPurchasedCount() {
        return this.purchasedCount;
    }

    /**
     * @param {number} purchasedCount 
     */
    setPurchasedCount(purchasedCount) {
        this.purchasedCount = purchasedCount;
    }

    /**
     * @param {number} purchasedCount The number of upgrade purchases that have been made. 
     */
    setPurchasedCountFromSave(purchasedCount) {
        // Update the building count.
        this.setPurchasedCount(purchasedCount);
    }

    /**
     * @abstract
     * @returns {boolean} true if the purchase was made.
     */
    purchase() {
        return false;
    }

    /**
     * @override
     */
    resetUpgrade() {
        this.purchasedCount = 0;
    }
}